import type { PropsWithChildren } from 'react';

import Text from '@/components/Text';

const Section = ({
  label,
  className,
  children,
}: PropsWithChildren<{ label: string; className?: string }>) => {
  return (
    <div className="flex flex-col gap-2">
      <Text className="font-semibold" variant="h5">
        {label}
      </Text>
      <div className={className}>{children}</div>
    </div>
  );
};

export default Section;
